export function resolveRingItemAngle(args) {
    const placement = args.layout.angularPlacement;
    if (placement?.placementKind === 'explicit') {
        const angle = placement.angleByItemKey[args.itemKey];
        if (angle === undefined) {
            throw new Error(`Explicit ring angular placement has no angle for '${args.itemKey}'.`);
        }
        if (!Number.isFinite(angle)) {
            throw new Error(`Explicit ring angle for '${args.itemKey}' must be finite.`);
        }
        return angle;
    }
    if (args.itemCount <= 0) {
        throw new Error('Cannot resolve an evenly spaced ring angle without items.');
    }
    return (placement?.startAngle ?? 0) + (args.itemIndex / args.itemCount) * Math.PI * 2;
}
